import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { CohearingMessage } from "../../../../models/CohearingMessage";
import { createTemporaryId } from "../../../../utils/model";
import { TelephonyContext } from "../../TelephonyContext";
import { GenericChatSectionTab } from "../../GenericChatSection/GenericChatSection";

export class HistoricCohearingMessage extends CohearingMessage {
  readonly error?: any;
  readonly key: string = createTemporaryId();

  constructor(deriveFrom?: Partial<HistoricCohearingMessage>) {
    super(deriveFrom);

    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}

/**
 * Allows elements to be rendered in the telephony viewport widget header,
 * or some other place.
 */
export const CohearingMessageSectionContextProvider: React.FC = ({ children }) => {
  const [tab, setTab] = useState(GenericChatSectionTab.StandardMessages);
  const [history, setHistory] = useState<HistoricCohearingMessage[]>([]);
  const telephonyContext = useContext(TelephonyContext);

  useEffect(() => {
    if (telephonyContext.cohearing.user?.userId || telephonyContext.cohearing.call?.call.id) {
      //  Clear between users or calls.
      setHistory([]);
    }
  }, [telephonyContext.cohearing.user?.userId, telephonyContext.cohearing.call?.call.id]);

  return (
    <CohearingMessageSectionContext.Provider value={{
      tab,
      setTab,
      history,
      addHistory(message) {
        setHistory(history => [...history, message]);
      },
      updateHistory(messageIdOrKey, update) {
        setHistory(history => history.map(message => {
          if (message.id === messageIdOrKey || message.key === messageIdOrKey) {
            return new HistoricCohearingMessage({ ...message, ...update });
          }

          return message;
        }))
      },
    }}>
      {children}
    </CohearingMessageSectionContext.Provider>
  )
}

export const CohearingMessageSectionContext = createContext<{
  tab: GenericChatSectionTab;
  setTab: (tab: GenericChatSectionTab) => void;
  history: HistoricCohearingMessage[];
  addHistory: (message: HistoricCohearingMessage) => void;
  updateHistory: (messageIdOrKey: string, update: Partial<HistoricCohearingMessage>) => void;
}>(null);